import(/* webpackMode: "eager" */ "/Users/r.wichmann/workspace/_private/robinwichmann.com/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageClient"] */ "/Users/r.wichmann/workspace/_private/robinwichmann.com/src/components/home/HomePageClient.tsx");
